import 'src/common/styles/destyle.scss';
import 'src/common/styles/globals.scss';
import { FC, useState } from 'react';

import type { AppProps } from 'next/app';

import { CookiesProvider } from 'react-cookie';
import { QueryClient, QueryClientProvider } from 'react-query';
import { RecoilRoot } from 'recoil';

import NotificationBar from '@components_iqloud/form/NotificationBar';

import { NotificationText } from '@constants_iqloud';

import CommonHead from '@components_common/common_head/CommonHead';
import { usePageView, GoogleAnalytics } from '@components_common/gtag/gtag';
import PageLoader from '@components_common/page_loader/PageLoader';
import { authContext } from '@contexts_common/authContext';
import { notificationContext } from '@contexts_common/notificationContext';
import { useProvideAuth } from '@hooks_common/useAuth';

if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
  //require('../mocks');
}

function MyApp({ Component, pageProps }: AppProps) {
  const [queryClient] = useState(() => new QueryClient());

  usePageView();

  return (
    <>
      <CommonHead />
      <GoogleAnalytics />
      <CookiesProvider>
        <RecoilRoot>
          <QueryClientProvider client={queryClient}>
            <InsideRecoilRoot Component={Component} pageProps={pageProps} />
          </QueryClientProvider>
        </RecoilRoot>
      </CookiesProvider>
    </>
  );
}

//useAuthの中でrecoilを使っているので、RecoilRootの中のコンポーネントでuseAuthを使わないとエラーになる
const InsideRecoilRoot: FC<any> = ({ Component, pageProps }: AppProps) => {
  const auth = useProvideAuth();
  const [showNotificationBar, setNotificationDisplay] = useState<boolean>(false);
  const [status, setNotificationStatus] = useState<'success' | 'alert'>('alert');
  const [message, setNotificationMessage] = useState<string>(NotificationText.invalidValue);
  return (
    <authContext.Provider value={auth}>
      <notificationContext.Provider value={{ setNotificationDisplay, setNotificationMessage, setNotificationStatus }}>
        <NotificationBar
          open={showNotificationBar}
          toggle={(prevState: boolean) => setNotificationDisplay(!prevState)}
          close={() => setNotificationDisplay(false)}
          message={message}
          status={status}
        />
        <PageLoader />
        <Component {...pageProps} />
      </notificationContext.Provider>
    </authContext.Provider>
  );
};

export default MyApp;
